///<reference path="../../../components/baseClasses/employeeSectionBase.ts"/>

module Meevo.Plugins.ProfileSettings {
    "use strict";

    /**
    * Main Section of ProfileSettings 
    */
    export class MainSection extends Meevo.Components.BaseClasses.EmployeeSectionBase<Model.ProfileSettings> {

        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Components.Logging.ILoggingService,
            dataService: Components.BaseClasses.IDataService,
            protected identityService: Components.Common.IIdentityService = null,
            noun: Model.NounEnum = null,
            appSettings: Components.Common.IAppSettings,
            sectionSecurityKey?: string) {
            super(sectionId,
                displayNameContentKey,
                template,
                isPrimarySection,
                handlesOwnCrud,
                baseEndpoint,
                sectionEndpoint,
                loggingService,
                dataService,
                identityService,
                noun,
                appSettings,
                sectionSecurityKey);
        }


    }
}